<template>
  <v-card class="mb-8">
    <v-card-title>注文通知設定</v-card-title>
    <v-card-text>
      <div class="d-flex align-center mb-2">
        <span class="mr-3 text-body-2 text--secondary">現在のあなたの通知設定:</span>
        <v-chip
          :color="hasNotification ? 'primary' : 'grey'"
          small
          outlined
        >
          {{ notificationLabel }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup() {
    // ログイン時に保存される自分の通知購読（channel_subscriptions）。
    // selfOrder ストアと同じ localStorage 'channelSubscriptions' を参照する。
    const subscriptions = (() => {
      try {
        return JSON.parse(localStorage.getItem('channelSubscriptions') || '[]')
      } catch {
        return []
      }
    })()

    const selfOrderNames = computed(() => subscriptions
      .filter(sub => (sub.channelName || sub.channel_name) === 'self_order')
      .map(sub => sub.name)
      .filter(Boolean))

    const hasNotification = computed(() => selfOrderNames.value.length > 0)
    const notificationLabel = computed(() => (hasNotification.value
      ? selfOrderNames.value.join('、')
      : '通知なし'))

    return { hasNotification, notificationLabel }
  },
})
</script>
